export default "<div class=\"home\">\n    <img src=\"assets/img/logo.justmenu.dark.svg\" alt=\"\">\n</div>"